var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComparison = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none",
  viewBox: "0 0 24 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.583 2.598h-5.26a2.4 2.4 0 0 0-4.647 0h-5.26l-3.85 8.34.72 2.873 2.774 1.386h2.083l2.773-1.386.72-2.873L6.337 3.8h3.339a2.41 2.41 0 0 0 1.723 1.724V18.8H6V20h12v-1.2h-5.4V5.524A2.41 2.41 0 0 0 14.324 3.8h3.339l-3.296 7.14.72 2.873L17.86 15.2h2.083l2.774-1.387.72-2.873-3.853-8.342ZM5.1 3.982 8.063 10.4H2.137zM5.86 14H4.34l-2.026-1.013-.347-1.387h6.265l-.346 1.387L5.858 14ZM12 4.4A1.2 1.2 0 1 1 12 2a1.2 1.2 0 0 1 0 2.4m6.9-.418 2.964 6.418h-5.926zM19.659 14H18.14l-2.026-1.013-.347-1.387h6.263l-.347 1.387z"
})));
export default SvgComparison;